
function Layout({ children }) {
  return (
    <div
      className="max-w-4xl mx-auto p-6 text-blue-600"
    >
      {children}

    </div>
  );
}

export default Layout;
